export const MIN_LENGTH = 5;
export const EMAIL_REGEX = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);

export const IS_INVALID = 'is-invalid';
export const IS_REQUIRED = 'is-required';
export const IS_VISIBLE = 'is-visible';

export const MAX_FILE_SIZE = 10485760;
export const ALLOWED_FILE_TYPES = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'application/vnd.oasis.opendocument.text'];
